export interface ArticleMeta {
  slug: string;
  updated: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: "usfans-spreadsheet-guide",
    updated: "2026-08-20",
    image:
      "https://readdy.ai/api/search-image?query=A_clean_organized_workspace_with_a_laptop_showing_a_colorful_spreadsheet_table_next_to_a_notebook_and_small_fashion_accessories_on_a_bright_cream_desk_soft_natural_light_high_detail_editorial_photography_fresh_minimal_aesthetic&width=1200&height=750&seq=article-spreadsheet-guide-v2&orientation=landscape",
  },
  {
    slug: "usfans-review",
    updated: "2026-08-18",
    image:
      "https://readdy.ai/api/search-image?query=A_modern_review_concept_with_five_gold_star_icons_and_a_clean_notebook_and_pen_on_a_warm_wooden_desk_with_a_cup_of_coffee_soft_natural_light_high_detail_editorial_photography_trustworthy_fresh_aesthetic&width=1200&height=750&seq=article-review-v2&orientation=landscape",
  },
  {
    slug: "usfans-shipping-cost",
    updated: "2026-08-15",
    image:
      "https://readdy.ai/api/search-image?query=A_stack_of_kraft_cardboard_delivery_boxes_with_packing_tape_and_a_shipping_label_on_a_bright_workspace_table_with_a_roll_of_bubble_wrap_soft_natural_light_high_detail_editorial_photography_logistics_fresh_aesthetic&width=1200&height=750&seq=article-shipping-v2&orientation=landscape",
  },
  {
    slug: "usfans-creator-directory",
    updated: "2026-08-14",
    image:
      "https://readdy.ai/api/search-image?query=An_open_directory_style_desk_with_a_laptop_showing_a_list_of_profile_cards_and_a_pen_holder_with_colorful_pens_on_a_light_wooden_table_soft_natural_light_high_detail_editorial_photography_organized_browseable_fresh_aesthetic&width=1200&height=750&seq=article-creator-directory-v2&orientation=landscape",
  },
  {
    slug: "usfans-coupon-guide",
    updated: "2026-08-13",
    image:
      "https://readdy.ai/api/search-image?query=A_fresh_flat_lay_of_a_scissors_cutting_a_blue_discount_voucher_next_to_a_small_wallet_and_a_receipt_on_a_soft_cream_background_with_gentle_natural_light_high_detail_editorial_photography_savings_clean_fresh_aesthetic&width=1200&height=750&seq=article-coupon-v2&orientation=landscape",
  },
  {
    slug: "usfans-discount-code",
    updated: "2026-08-12",
    image:
      "https://readdy.ai/api/search-image?query=A_smartphone_showing_a_promo_code_screen_next_to_a_shopping_bag_and_a_credit_card_on_a_bright_minimal_desk_with_a_small_plant_soft_natural_light_high_detail_editorial_photography_online_shopping_fresh_aesthetic&width=1200&height=750&seq=article-discount-v2&orientation=landscape",
  },
  {
    slug: "usfans-warehouse-guide",
    updated: "2026-08-11",
    image:
      "https://readdy.ai/api/search-image?query=A_bright_organized_warehouse_interior_with_tall_shelves_of_boxed_products_and_a_worker_with_a_clipboard_soft_diffused_light_high_detail_editorial_photography_logistics_and_storage_fresh_clean_aesthetic&width=1200&height=750&seq=article-warehouse-v2&orientation=landscape",
  },
  {
    slug: "usfans-legit-safety",
    updated: "2026-08-10",
    image:
      "https://readdy.ai/api/search-image?query=A_modern_shield_icon_with_a_checkmark_next_to_a_locked_padlock_and_a_smartphone_on_a_bright_clean_desk_with_soft_natural_light_high_detail_editorial_photography_security_trust_and_privacy_fresh_aesthetic&width=1200&height=750&seq=article-safety-v2&orientation=landscape",
  },
  {
    slug: "usfans-comparison-guide",
    updated: "2026-08-09",
    image:
      "https://readdy.ai/api/search-image?query=A_split_desk_scene_with_two_laptops_showing_different_comparison_tables_side_by_side_and_a_notebook_with_charts_on_a_bright_table_soft_natural_light_high_detail_editorial_photography_decision_making_fresh_aesthetic&width=1200&height=750&seq=article-comparison-v2&orientation=landscape",
  },
  {
    slug: "usfans-faq",
    updated: "2026-08-08",
    image:
      "https://readdy.ai/api/search-image?query=A_bright_desk_with_a_notebook_full_of_question_marks_and_a_mug_of_tea_with_a_small_plant_soft_natural_light_high_detail_editorial_photography_helpful_answers_fresh_aesthetic&width=1200&height=750&seq=article-faq-v2&orientation=landscape",
  },
  {
    slug: "usfans-creator-list",
    updated: "2026-08-07",
    image:
      "https://readdy.ai/api/search-image?query=A_clean_desk_with_a_laptop_displaying_a_long_scrollable_list_of_names_and_avatars_next_to_a_notebook_and_a_pen_soft_natural_light_high_detail_editorial_photography_curated_directory_fresh_aesthetic&width=1200&height=750&seq=article-creator-list-v2&orientation=landscape",
  },
  {
    slug: "usfans-search-tips",
    updated: "2026-08-06",
    image:
      "https://readdy.ai/api/search-image?query=A_magnifying_glass_resting_on_a_laptop_keyboard_next_to_a_notepad_with_written_notes_on_a_bright_wooden_desk_soft_natural_light_high_detail_editorial_photography_research_and_discovery_fresh_aesthetic&width=1200&height=750&seq=article-search-tips-v2&orientation=landscape",
  },
  {
    slug: "usfans-beginner-guide",
    updated: "2026-08-05",
    image:
      "https://readdy.ai/api/search-image?query=A_bright_desk_with_an_open_notebook_writing_guide_tips_a_laptop_and_a_cup_of_coffee_next_to_a_small_succulent_soft_morning_light_high_detail_editorial_photography_welcoming_start_fresh_aesthetic&width=1200&height=750&seq=article-beginner-v2&orientation=landscape",
  },
];